import React, { useState, useEffect, useContext } from 'react';
import { getAllRadios, RadioProps } from '../../api';
import RadioConfigContext from '../../context/RadioConfigContext/RadioConfigContext';
import SingleRadio from './components/SingleRadio/SingleRadio';
import BeatLoader from "react-spinners/BeatLoader";
import { ListingBox, ListingBoxGrid, LoadingBox, FilterGenreBox, ClearFilter, FilteresBox } from './Listing.css';
import { storageKey } from '../../App';


const Listing = (props: { inputValue: string, showFavs: boolean }): JSX.Element => {
  const { inputValue } = props;
  const [radios, setRadios] = useState<RadioProps[]>([]);
  const [filteredRadios, setFilteredRadios] = useState<RadioProps[]>([]);
  const [loading, setLoading] = useState(true);
  const storageMain = (window.localStorage.getItem(storageKey) ? window.localStorage.getItem(storageKey) : '[]') as string;
  const [currentFavs, setCurrentFavs] = useState(JSON.parse(storageMain) as RadioProps[]);
  const [filteredCurrentFavs, setFilteredCurrentFavs] = useState(JSON.parse(storageMain) as RadioProps[]);
  const { radioConfig, setRadioConfig } = useContext(RadioConfigContext);

  useEffect(() => {
    void (async function () {
      setLoading(true);
      const allRadios = await getAllRadios(radioConfig.lang, radioConfig.currentCategory);
      setRadios(allRadios);
      setFilteredRadios(allRadios);
      setLoading(false);
    })();
  }, [radioConfig.lang, radioConfig.currentCategory]);

  useEffect(() => {
    setFilteredRadios([...radios.filter(x => x.name.toLowerCase().indexOf(inputValue.toLowerCase()) > - 1)]);
    setFilteredCurrentFavs([...currentFavs.filter(x => x.name.toLowerCase().indexOf(inputValue.toLowerCase()) > - 1)]);
  }, [inputValue]);

  useEffect(() => {
    const storage = (window.localStorage.getItem(storageKey) ? window.localStorage.getItem(storageKey) : '[]') as string;
    setCurrentFavs(JSON.parse(storage) as RadioProps[]);
  }, [props.showFavs])

  const handleClearFilter = () => {
    setRadioConfig({...radioConfig, currentCategory: 0, currentCategoryName: ''});
  };

  const changeFavs = () => {
    const storage = (window.localStorage.getItem(storageKey) ? window.localStorage.getItem(storageKey) : '[]') as string;
    const newFavs = JSON.parse(storage) as RadioProps[];
    setCurrentFavs(newFavs);
    setFilteredCurrentFavs([...newFavs.filter(x => x.name.toLowerCase().indexOf(inputValue.toLowerCase()) > - 1)]);
  }

  return (
    <ListingBox>
      {props.showFavs && <FilteresBox><FilterGenreBox style={{backgroundColor: '#F23C3C'}}>FAVOURITES</FilterGenreBox></FilteresBox>}
      {radioConfig.currentCategory > 0 && <FilteresBox><FilterGenreBox>GENRE: {radioConfig.currentCategoryName}<ClearFilter onClick={handleClearFilter}><i className="fa fa-times" /></ClearFilter></FilterGenreBox></FilteresBox>}
      {loading ? <LoadingBox><BeatLoader color="#999" size={10} loading={true} /></LoadingBox> :
      <ListingBoxGrid>
        {props.showFavs ? filteredCurrentFavs.map((radio: RadioProps) => <SingleRadio {...radio} showFavs={props.showFavs} changeFavs={changeFavs}  />) :  filteredRadios.map((radio: RadioProps) => <SingleRadio {...radio} showFavs={props.showFavs} changeFavs={changeFavs} />)}
      </ListingBoxGrid>}
    </ListingBox>
  );
};

export default Listing;